/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="15.59" height="15.59" viewBox="0 0 15.59 15.59" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="M682.53,375.88a7.8,7.8,0,1,1-7.79,7.79A7.79,7.79,0,0,1,682.53,375.88Zm0,1a6.8,6.8,0,1,0,6.79,6.79A6.79,6.79,0,0,0,682.53,376.88Zm-.9,2.42h1l0,4.24h4.79v1h-5.8Z" transform="translate(-674.74 -375.88)" className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'ClockUtilityIcon';

export default Icon;
